export * from './stock-in-bin.component';